import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";

const Home = () => {
  const navigate = useNavigate();

  // On /allpages the book library renders right below the hero
  const handleStartLearning = () => {
    const library = document.querySelector(".book-page-container");
    if (library) {
      library.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/allpages");
    }
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">🎓 # Educational Platform</div>
            <h1 className="hero-title">
              Unlock Your <span className="hero-title-gradient">Potential</span>
            </h1>
            <p className="hero-description">
              Transform your career with knowledge that matters.
            </p>
          </div>

          <div className="hero-buttons">
            <button className="hero-btn primary" onClick={handleStartLearning}>
              Start Learning Today <span className="btn-arrow">→</span>
            </button>
            <button className="hero-btn secondary" onClick={() => navigate("/CourseCard")}>
              Explore Courses <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
